// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const SpeakerphoneIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Speakerphone/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 3a1 1 0 0 0-1.447-.894L8.764 6H5a3 3 0 0 0 0 6h.28l1.771 5.316a1 1 0 0 0 .95.684h1a1 1 0 0 0 1-1v-4.382l6.552 3.276A1 1 0 0 0 18 15V3Z"
}));
export default SpeakerphoneIcon;